(function($) {
	// Home Page
	$(".services-section .et_pb_column").hover(function() {
			$(this).addClass("overlayed");
		}, function() {
			$(this).removeClass("overlayed");
		});

	// About Page

	//Hover over team members and show title/ name
	$(".team-section .et_pb_column").hover(function() {
			$(this).addClass("overlayed");
		}, function() {
			$(this).removeClass("overlayed");
		});

	// Home Page Testimonial Logic
	$(document).ready(function () {
		let activeTest = $(".et_pb_section.testimonials-section .et_pb_row .et_pb_column .et_pb_module.et_pb_testimonial:first-of-type");
		activeTest.addClass("active");
	});

	// Home Page Testimonial Navigation
	$(".et_pb_section.testimonials-section #prev-nav").click(
		function(e) {
			let active = $(".et_pb_section.testimonials-section .et_pb_row .et_pb_column .et_pb_module.et_pb_testimonial.active");
			active.removeClass('active');

			if (active.prev().length == 0) {
				active.nextAll().last().addClass('active');
			} else {
				active.prev().addClass("active");
			}
		}
	);

	$(".et_pb_section.testimonials-section #next-nav").click(
		function(e) {
			let active = $(".et_pb_section.testimonials-section .et_pb_row .et_pb_column .et_pb_module.et_pb_testimonial.active");
			active.removeClass("active");

			if (active.next().length == 0) {
				active.prevAll().first().addClass('active');
			} else {
				active.next().addClass("active");
			}
		}
	);

	// Services Page Menu
	$("#choose-a-service").click(function(e) {
		$("#services-mobile-navigation .sub-menu").toggleClass('active');
	});

	// close service sub-menu
	$(document).click(function (event) {
		$target = $(event.target);

		if (
			event.target.id !== "choose-a-service" &&
			$("#services-mobile-navigation .sub-menu").hasClass("active") &&
			$target.closest("#services-mobile-navigation .sub-menu").length === 0 ) {
				$("#services-mobile-navigation .sub-menu").removeClass("active");
		}
	});

	// Service Page Video Slider Navigation
	$(".et_pb_section.video-slider #prev-nav").click(
		function (e) {
			let active = $(".et_pb_section.video-slider .et_pb_row .et_pb_column .et_pb_module.et_pb_video.active");
			active.removeClass('active');

			if (active.prev().length == 0) {
				active.nextAll().last().addClass('active');
			} else {
				active.prev().addClass("active");
			}
		}
	);

	$(".et_pb_section.video-slider #next-nav").click(
		function (e) {
			let active = $(".et_pb_section.video-slider .et_pb_row .et_pb_column .et_pb_module.et_pb_video.active");
			active.removeClass("active");

			if (active.next().length == 0) {
				active.prevAll().first().addClass('active');
			} else {
				active.next().addClass("active");
			}
		}
	);

	/**
	 * Request a Quote toggle
	 */
	$('.request-a-quote-toggle h4').click(function(e) {
		if ($('.request-a-quote-toggle').hasClass('open')) {
			closeForm();
		}
		else {
			openForm();
		}

	});

	$('a[href$="#request-quote"]').click(function(e) {
		openForm();

		//Close the mobile menu (if open)
		if ($('#mobile-navigation.open').length) {
			$('label.menu-toggle').trigger('click');
		}

	});

	//Open the form if the page loads with the hash
	if (window.location.hash && window.location.hash == '#request-quote') {
		openForm();
	}

	console.log(window.location.hash);

	function closeForm() {
		$('.request-a-quote-form').slideUp();
		$('.request-a-quote-toggle').removeClass('open');
	}

	function openForm() {
		$('.request-a-quote-form').slideDown();
		$('.request-a-quote-toggle').addClass('open');
	}

	/**
	 * Request a Quote file upload
	 */
	$(document).on('click', '.request-a-quote-form .ginput_container_fileupload', function(e) {
		$(this).find('input[type=file]').trigger('click');
	});

	$(document).on('click', '.request-a-quote-form .ginput_container_fileupload input[type=file]', function(e) {
		e.stopPropagation();
	});

	$(document).on('change', '.request-a-quote-form .ginput_container_fileupload input[type=file]', function(e) {
		let file = $(this).val();

		//Strip out the rest to get just the file name
		file = file.split("\\");
		file = file[file.length-1];

		if (file) {
			$('.request-a-quote-form .ginput_container_fileupload').attr('data-file', file).addClass('hasFile');
		}
		else {
			$('.request-a-quote-form .ginput_container_fileupload').removeClass('hasFile').attr('data-file', '');
		}
	});

})(jQuery);
